import { TypologiesTable } from "./Table";


export function Typologies() {
  return (
    <div>
        <TypologiesTable />
    </div>
  )
}